export const COURSE_CATALOG = [
  {
    id: "frontend-career",
    name: "Frontend Development Career Program",
    tag: "LIVE + PROJECT BASED",
    duration: "8–10 Weeks",
    price: 19999,
    description:
      "Master modern frontend development with React, JavaScript, responsive UI design, Git, APIs, debugging, deployment, and real-world project building.",
    highlights: [
      "React + JavaScript",
      "Git & GitHub",
      "Real Projects",
      "Resume Guidance",
      "Portfolio Building",
      "Interview Preparation",
    ],
  },
  {
    id: "fullstack-trainee",
    name: "Full Stack Developer Trainee Program",
    tag: "COMING SOON",
    duration: "12–16 Weeks",
    price: 39999,
    description:
      "An advanced career-track program combining full stack development, production projects, mentorship, and internship-style trainee experience.",
    highlights: [
      "Frontend + Backend + Database",
      "Internship Style Training",
      "Real Startup Projects",
      "Code Reviews & Mentorship",
      "Team Collaboration",
      "Certificate & Career Support",
    ],
  },
];

export const getCourseById = (courseId) =>
  COURSE_CATALOG.find((course) => course.id === courseId) || COURSE_CATALOG[0];